import React from 'react';
import amenitiesWithIcons from '../../data/amenitiesWithIcons';
import '../../components/Styles/ClientPage.css';

const IconStrip = ({ venueDetails }) => {
  const venue = venueDetails?.responseContent?.venueDetails || [];
  const amenities = venue?.[0]?.amenities || [];

  const filteredIcons = amenitiesWithIcons.filter(item => 
    amenities.includes(item.value)
  );

  return ( 
    <div className="icon-strip">
      {filteredIcons.map(({ icon, label }, index) => (
        <div className="icon-strip__icon group relative" key={index}>
          {icon}
          <span className="icon-strip__tooltip">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default IconStrip;
